// ============================================================================
// ORDERS · Collection — the line (C8 Commit 2): Sun or Optic
// ============================================================================
// D-C8-1: Sun and Optic are fully separate; every Collection view follows one
// switch, Sun by default. The line is the SAME axis as the Book's Sun / Optic
// rail (Conv #141) — the store's bookKind, on the address as &book=optic
// (useOrdersUrl). It is not &line=: that key is the Book row deep link.
// Changing the line closes the open drawer and clears the facets of both
// toolbars (their values belong to the other line); the search, the tab and
// the status seg stay. C8 Commit 3 · the Wall deck's picks (family, materials,
// sub-shapes) belong to a line too and reset with it; Not ordered yet stays. The Book's own setter also resets its sub-collection,
// so this one does the same.
// ============================================================================
import { useCallback } from 'react';
import { useOrdersUiStore } from '../ordersUiStore';
import { lineOf } from './api';
import { resetCollectionForLine } from './collectionLineReset';

export function useCollectionLine() {
  const line = useOrdersUiStore((st) => lineOf(st.bookKind));
  const setLine = useCallback((next) => { resetCollectionForLine(useOrdersUiStore.getState(), next); }, []);
  return { line, setLine };
}
